import { render, staticRenderFns } from "./ui-dialog.vue?vue&type=template&id=5531d237&"
import script from "./ui-dialog.vue?vue&type=script&lang=ts&"
export * from "./ui-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ui-dialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports